import { POST } from '@/api'
import { cloneDeep, isEqual, sortBy, without } from 'lodash'
import Vue from 'vue'

const INITIAL_DATE = {
  ranges: [],
  times: [],
}

/**
 * 予約受付時間編集
 */
export default {
  namespaced: true,
  state: {
    byDay: {},
    dates: [],
    busy: false,
  },
  mutations: {
    set(state, { byDay, dates }) {
      state.byDay = cloneDeep(byDay)
      state.dates = cloneDeep(dates)
    },
    updateDay(state, byDay) {
      state.byDay = { ...state.byDay, ...byDay }
    },
    toggleDay(state, { day, time }) {
      state.byDay = {
        ...state.byDay,
        [day]: state.byDay[day].includes(time)
          ? without(state.byDay[day], time)
          : sortBy(state.byDay[day].concat(time)),
      }
    },
    addDate(state) {
      state.dates = state.dates.concat(INITIAL_DATE)
    },
    removeDate(state, index) {
      state.dates = state.dates.filter((_, i) => i !== index)
    },
    updateDate(state, { index, date }) {
      Vue.set(state.dates, index, { ...state.dates[index], ...date })
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    allDays: ({ byDay }) => [1, 2, 3, 4, 5, 6, 0, -1, -2].map(day => ({ day, times: byDay[day] })),
    changed: ({ byDay, dates }, getters, { reception }) =>
      dates.every(({ ranges }) => ranges.length) &&
      (!isEqual(byDay, reception.times.byDay) || !isEqual(dates, reception.times.dates)),
  },
  actions: {
    async start(store) {
      const { reception } = store.rootState
      if (!Object.keys(reception.times.byDay).length) await store.dispatch('reception/times/get', null, { root: true })
      store.commit('set', reception.times)
    },
    async save(store) {
      const { commit, state } = store
      commit('busy', true)

      const { status, message } = await POST('/api/web/reception/time/update', {
        day: state.byDay,
        dates: state.dates,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async removeDate(store, index) {
      await store.dispatch('start')
      store.commit('removeDate', index)
      return store.dispatch('save')
    },
  },
}
